import type { IconSvgObject } from './types';

const ArchiveOff04Icon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3H16.6459C17.4637 3 18.1992 3.4979 18.5029 4.25722L21.857 12.6424C21.9514 12.8786 22 13.1307 22 13.3852V18M21 21H4C2.89543 21 2 20.1046 2 19V13.3852C2 13.1307 2.04855 12.8786 2.14305 12.6424L5.14286 5.14286", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 13H6.17157C6.70201 13 7.21071 13.2107 7.58579 13.5858L8.41421 14.4142C8.78929 14.7893 9.29799 15 9.82843 15H15M17 13H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArchiveOff04Icon;
